import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Testimonials() {
  return <div className="bg-sage-light/20 border-y border-beige-muted/50" data-id="element-204">
      <Section data-id="element-205">
        <SectionTitle data-id="element-206">Lo que dicen las mamás que ya lo usan</SectionTitle>

        <div className="grid md:grid-cols-3 gap-8 items-start mt-12" data-id="element-207">
          {/* Card 1 — Mamá agotada */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-208">
            <div className="flex items-center gap-4 mb-4" data-id="element-209">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-210">
                <span className="text-white font-bold text-sm" data-id="element-211">MC</span>
              </div>
              <div data-id="element-212">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-213">Micaela C.</h3>
                <p className="text-sm text-charcoal-light" data-id="element-214">
                  Mamá de León, 8 meses — CABA
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-215">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-216" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-217">
              "Estaba súper agotada y sentía que no hacía lo suficiente por él.
              La guía me salvó, literal. Son cosas re simples que hacemos
              mientras cocino o lo baño. Me sacó un peso de encima enorme."
            </p>
          </div>

          {/* Card 2 — Mamá primeriza */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-218">
            <div className="flex items-center gap-4 mb-4" data-id="element-219">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-220">
                <span className="text-white font-bold text-sm" data-id="element-221">FL</span>
              </div>
              <div data-id="element-222">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-223">
                  Florencia L.
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-224">
                  Mamá de Alma, 3 meses — Rosario
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-225">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-226" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-227">
              "Como mamá primeriza leía de todo y me mareaba. Esto es directo al
              grano. Me encantó que no necesito comprar juguetes caros, usamos
              cosas de casa y ella se re divierte. Súper recomendable."
            </p>
          </div>

          {/* Card 3 — Menos pantallas */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-228">
            <div className="flex items-center gap-4 mb-4" data-id="element-229">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-230">
                <span className="text-white font-bold text-sm" data-id="element-231">SG</span>
              </div>
              <div data-id="element-232">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-233">Sofía G.</h3>
                <p className="text-sm text-charcoal-light" data-id="element-234">
                  Mamá de Mateo, 2 años — Córdoba
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-235">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-236" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-237">
              "Quería bajarle el tiempo de tele a Mateo pero se me acababan las
              ideas. El bono de 30 ideas sin pantallas es oro puro. Ahora
              jugamos más juntos y lo noto mucho más tranquilo a la tarde."
            </p>
          </div>
        </div>
      </Section>
    </div>;
}